var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillingSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6274 -2.89694e-07 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 2.89694e-07 18.6274 0 12C-2.89694e-07 5.37258 5.37258 2.89694e-07 12 0Z",
    fill: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2Z",
    fill: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C17.2467 21.5 21.5 17.2467 21.5 12ZM22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z",
    fill: "#1953FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9179 9.21871C14.0475 9.08269 14.2577 9.08269 14.3873 9.21871L16.047 10.9602C16.1766 11.0962 16.1766 11.3168 16.047 11.4528L14.3873 13.1943C14.2577 13.3303 14.0475 13.3303 13.9179 13.1943C13.7882 13.0582 13.7882 12.8377 13.9179 12.7017L15.0109 11.5548L11.3169 11.5548L11.3167 11.2065L11.3169 10.8582L15.0109 10.8582L13.9179 9.71128C13.7882 9.57526 13.7882 9.35473 13.9179 9.21871Z",
    fill: "#1953FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59227 15.2841C9.46264 15.4201 9.25247 15.4201 9.12285 15.2841L7.46319 13.5426C7.33356 13.4066 7.33356 13.1861 7.46319 13.05L9.12285 11.3085C9.25248 11.1725 9.46264 11.1725 9.59227 11.3085C9.7219 11.4446 9.7219 11.6651 9.59227 11.8011L8.49925 12.948L12.1932 12.948L12.1934 13.2963L12.1932 13.6446L8.49925 13.6446L9.59227 14.7915C9.7219 14.9275 9.7219 15.1481 9.59227 15.2841Z",
    fill: "#1953FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingSwitch);
export default __webpack_public_path__ + "react/media/billing-switch.252dfff63d140d91c956511a832d2d8e.svg";
export { ForwardRef as ReactComponent };